/*
 * @Author: cc
 * @Date: 19-11-27
 * @LastEditTime: 2021-04-08 20:07:36
 * @LastEditors: lzy
 * @FilePath: \xjmediacloud\app\components\service\message\message.js
 * @Description:消息机制，解决跨作用域通信问题
 */
angular.module('messagePublishModule', []).factory('messagePublishService', [
    '$rootScope',
    function ($rootScope) {
        let listenerGather = {}; // 监听事件集合
        return {

            /**
             * [publish description]消息发布者
             * @param  {[type]} name   [description]
             * @param  {[type]} params [description]
             * @param  {[type]} noClear [description]
             * @return {[type]}        [description]
             */
            publish: function (name, params, noClear) {
                if ($rootScope.$$listenerCount[name] && $rootScope.$$listenerCount[name] < 2) { // 避免多次执行的情况
                    $rootScope.$emit(name, params);
                } else {
                    if (listenerGather[name]) {
                        if (!noClear) {
                            // listenerGather[name](); // 先清除在使用
                            $rootScope.$$listeners[name].splice(0, $rootScope.$$listeners[name].length - 1);
                        }
                        $rootScope.$emit(name, params);
                    }
                }
            },

            /**
             * [configPublish description] 传递配置项，为了与以前的发布方法区分开，这里需要多个
             * @param   {[type]}  name    [name description]
             * @param   {[type]}  params  [params description]
             * @return  {[type]}          [return description]
             */
            configPublish: function(name, params){
                $rootScope.$emit(name, params);
            },

            /**
             * [subscribe description] 消息订阅者
             * @param   {[string]}  name        [name description] 发布消息名称
             * @param   {[Function]} listener   [listener description] 监听器（糊掉函数）
             * @param   {[object]}  scope       [scope description] 当前订阅者的作用域
             * @return  {[type]}            [return description]
             */
            subscribe: function (name, listener, scope) {
                var unbind = $rootScope.$on(name, listener);
                listenerGather[name] = unbind;
                // 可控的事件反绑定机制
                if (scope) {
                    scope.$on('$destroy', unbind);
                }
            },
        };
    },
]);
